let reviews = document.querySelectorAll('.reviews-item')

if (reviews.length) {
    for (let review of reviews) {
        review.addEventListener('click', () => {
            let { images } = review.dataset
            let options = []
            let type = 'image'

            images = images.split(';')

            for (let src of images) {
                options.push({ src, type })
            }

            Fancybox.show(options)
        })
    }
}

/////

let newReviews = document.querySelector('.reviews-slider')

if (newReviews) {
    let companies = document.querySelectorAll('.review-companies-item')

    newReviews.slider = new Swiper(newReviews, {
        slidesPerView: 1,
        slideClass: 'review-item',
        autoHeight: true,
        breakpoints: {
            768: {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
            },
        },
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next',
        }
    })

    if (companies.length) {
        for (let company of companies) {
            company.addEventListener('click', () => {
                let index = Number(company.dataset.index)

                newReviews.slider.slideTo(index)
            })
        }
    }

    newReviews.slider.on('slideChange', () => {
        let index = newReviews.slider.activeIndex

        if (companies.length) {
            let wrapper = document.querySelector('.review-companies')

            for (let company of companies) {
                let key = Number(company.dataset.index)

                if (key == index) {
                    wrapper.prepend(company)
                }
            }
        }
    })
}